import { AxiosResponse } from 'axios';
import { Users } from '../../models/users.model';
import { UsersService } from '../../services/users.service';

export default function RoleAuthenticator(userLog: any) {
    const userService = UsersService({ locale: 'en' });
    if (userLog) {
        const usuario = userLog.username ? userLog.username : userLog.idTokenClaims.email;
        userService.getUserByUserName(usuario).then((response: AxiosResponse) => {
            const data: Users = response.data;
            localStorage.setItem('Infra2_User', JSON.stringify(data));
            userService.getInfra2_UserGroups().then((p: AxiosResponse) => {
                const userGroups = p.data.filter((f: any) => f.Name.indexOf(' default') === -1);
                const roles = JSON.stringify(userGroups);
                localStorage.setItem('Roles', roles);
            });
        });
    }
}
